module.exports = __webpack_public_path__ + "img/back-single-oferta.3e08ea1b.webp";